import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { RichTextEditor } from '~components'

import styles from './UniversalTemplateFields.module.css'

const { Text } = Typography

const UniversalTemplateTextFields = ({ text, onChange }) => {
  const { content = '' } = text || {}

  const patch = updates => onChange({ ...text, ...updates })

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Content</Text>
        <Text className={styles.hint}>Use the editor below to write and format the text block.</Text>
        <div style={{ marginTop: 12 }}>
          <RichTextEditor
            minHeight={200}
            onChange={html => patch({ content: html })}
            placeholder="Write your text content here…"
            value={content}
          />
        </div>
      </div>
    </div>
  )
}

UniversalTemplateTextFields.propTypes = {
  onChange: PropTypes.func.isRequired,
  text: PropTypes.object
}

export default UniversalTemplateTextFields
